import React, { useEffect, useRef, useState } from 'react'
import { Button } from 'react-bulma-components'
import ReactMarkdown from 'react-markdown'
import { ThreeDots } from 'react-loader-spinner'
import * as styles from '../styles/chatbot.module.scss'
import Icon from './Icons/index.js'

const Chatbot = () => {
  const [isOpen, setIsOpen] = useState(false)
  const [messages, setMessages] = useState([
    {
      sender: 'bot',
      text: `Hello! 👋 Welcome to the world of WEGnology! 🌟
      \nI'm the WEGnology Agent, and I am here to make your experience simpler and more efficient on the platform, whether by answering questions, providing examples, or introducing features.
      \nCount on me for:
      \n🔍 Quick answers about the documentation; 
      \n💡 Practical examples to make your work easier; 
      \n🛠️ Tips to find what you need; 
      \n🚀 Exploring all the features of the platform. 
      \nAsk your question and let's get started! 😊`,
    },
  ])
  const [input, setInput] = useState('')
  const [userId, setUserId] = useState(null)
  const [threadSlug, setThreadSlug] = useState(null)
  const [isLoading, setIsLoading] = useState(false)
  const chatMessagesRef = useRef(null)
  const inputRef = useRef(null)

  const toggleChat = () => setIsOpen(!isOpen)

  const sendMessage = async () => {
    if (input.trim() === '' || isLoading) return

    const userMessage = { sender: 'user', text: input }
    setMessages((prev) => [...prev, userMessage])
    const currentInput = input
    setInput('')
    setIsLoading(true)

    try {
      const response = await fetch('/api/send-message', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          message: currentInput,
          userId,
          threadSlug,
        }),
      })

      const result = await response.json()

      if (!result.success) {
        throw new Error(result.message || 'Ocorreu um erro na resposta da API.')
      }

      const botResponse = { sender: 'bot', text: result.textResponse }
      setMessages((prev) => [...prev, botResponse])
      setUserId(result.userId)
      setThreadSlug(result.threadSlug)
    } catch (error) {
      const errorResponse = {
        sender: 'bot',
        text: `Desculpe, algo deu errado. Por favor, tente novamente mais tarde.`,
      }
      setMessages((prev) => [...prev, errorResponse])
      console.error('Falha ao enviar mensagem:', error)
    } finally {
      setIsLoading(false)
    }
  }

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') sendMessage()
  }

  const scrollToBottom = () => {
    if (chatMessagesRef.current) {
      chatMessagesRef.current.scrollTop = chatMessagesRef.current.scrollHeight
    }
  }

  useEffect(() => {
    scrollToBottom()
  }, [messages, isLoading])

  useEffect(() => {
    if (!isLoading && inputRef.current) {
      inputRef.current.focus()
    }
  }, [isLoading])

  return (
    <>
      {isOpen && (
        <div className={styles.chatbotBox}>
          <div className={styles.chatHeader}>
            <div className={styles.wendiWEGnology}>
              {/* <Icon glyph="WENDI" placement="white" /> */}
              <p>WEGnology Agent</p>
            </div>
            <Button className={styles.closeButton} onClick={toggleChat}>
              <Icon glyph="CLOSE" placement="white" />
            </Button>
          </div>
          <div className={styles.chatMessages} ref={chatMessagesRef}>
            {messages.map((msg, idx) => (
              <div
                key={idx}
                className={`${styles.messageBubble} ${
                  msg.sender === 'user' ? styles.user : styles.bot
                }`}
              >
                <div className={styles.messageText}>
                  <ReactMarkdown>{msg.text}</ReactMarkdown>
                </div>
              </div>
            ))}

            {isLoading && (
              <div className={`${styles.messageBubble} ${styles.bot}`}>
                <div
                  className={`${styles.messageText} ${styles.loadingPadding}`}
                >
                  <ThreeDots
                    height="40"
                    width="40"
                    radius="9"
                    color="#023867"
                    ariaLabel="three-dots-loading"
                    visible
                  />
                </div>
              </div>
            )}
          </div>
          <div className={styles.chatInputWrapper}>
            <input
              className={styles.chatInput}
              placeholder="Type your message..."
              name="message"
              type="text"
              value={input}
              onChange={(e) => setInput(e.target.value)}
              onKeyPress={handleKeyPress}
              disabled={isLoading}
              ref={inputRef}
            />
            <button
              type="button"
              className={styles.sendIcon}
              onClick={sendMessage}
              disabled={isLoading}
            >
              <Icon glyph="SEND" placement="#fff" />
            </button>
          </div>
        </div>
      )}

      <Button className={styles.chatbotToggle} onClick={toggleChat}>
        <Icon glyph="CHATBOT" placement="white" />
      </Button>
    </>
  )
}

export default Chatbot
